
import React from "react";
import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";

export default function ChatFeaturePopup(props) {
  const { data, ui, onUIClick } = useStateManager();
  const { showFeaturePopup } = ui ?? {};
  const openClass = showFeaturePopup ? "open" : "";

  return (
    <div className={`chat-popup feature-popup ${openClass}`}>
      <div className="feature-popup-container flex-container flex-vertical">
        <div className="flex-container flex-horizontal align-center feature-header">
          <div className="flex-width"></div>
          <div className="set-width clickable" onClick={onUIClick("showFeaturePopup", false)} >
            <SVGAsset id="MinusIcon" className="minus-icon feature-icon clickable" />
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="speaker-icon feature-icon" data-bcms-svg="speaker-icon"></div> */}
            <SVGAsset id="SpeakerIcon" className="speaker-icon feature-icon" data-point="Chat_Feature_Popup_Speaker_Icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">
              <span data-point="Chat_Feature_Popup_Start_Voice_Label">Start Voice</span>
            </p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="camera-icon feature-icon" data-bcms-svg="camera-icon"></div> */}
            <SVGAsset id="ChatCameraIcon" className="camera-icon feature-icon" data-point="Chat_Feature_Popup_Chat_Camera_Icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">
              <span data-point="Chat_Feature_Popup_Chat_Start_Video_Label">Start Video</span>
            </p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="monitor-icon feature-icon" data-bcms-svg="monitor-icon"></div> */}
            <SVGAsset id="ChatMonitorIcon" className="monitor-icon feature-icon" data-point="Chat_Feature_Popup_Chat_Monitor_Icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">
              <span data-point="Chat_Feature_Popup_Chat_Share_Desktop_Label">Share Desktop</span>
            </p>
          </div>
        </div>
        <div className="flex-container flex-horizontal align-center feature-item">
          <div className="set-width">
            {/* <div className="paper-clip-icon feature-icon" data-bcms-svg="paper-clip-icon"></div> */}
            <SVGAsset id="ChatPaperClipIcon" className="paper-clip-icon feature-icon" data-point="Chat_Feature_Popup_Chat_Paper_Clip_Icon" />
          </div>
          <div className="flex-width">
            <p className="feature-text">
              <span data-point="Chat_Feature_Popup_Upload_File_Label">Upload File</span>
            </p>
          </div>
        </div>
        <DisabledPrompt>
          <div className="flex-container flex-horizontal align-center feature-item active-item clickable">
            <div className="set-width ">
              {/* <div className="gear-setting-icon feature-icon" data-bcms-svg="gear-setting-icon"></div> */}
              <SVGAsset id="ChatGearIcon" className="gear-setting-icon feature-icon" data-point="Chat_Feature_Popup_Chat_Gear_Icon" />
            </div>
            <div className="flex-width">
              <p className="feature-text">
                <span data-point="Chat_Feature_Popup_Settings_Label">Settings</span>
              </p>
            </div>
          </div>
        </DisabledPrompt>

      </div>
    </div>
  )
}
